<template>
    <div @contextmenu.prevent>
        <!-- <h3>download</h3> -->
        <div>
            <div>     
                <h2 class=" text-center font-weight-bold letter-spacing-1"><i class="fas fa-info-circle me-4"></i>請直接點選下方圖片下載</h2>
            </div>
            <a :href='downloadLink'   :download = "generateFileName(item)" >
                <img :src='downloadLink' style="width:100%">
            </a>

        </div>
        
    </div>
</template>

<script>
import Utils from '../../utils/utils';
import CONST from '../../utils/const';
import { mapState, mapGetters } from 'vuex'
import moment from "moment";

export default{
    data(){
        return{
         item: {},
         downloadLink:''
        }
    },
    created(){
    const { id, area, dt, publicPlace, licensePlate, streamUrl} = this.$route.query;

    const item = {
    id: id,
    area: area,
    dt: dt,
    publicPlace:publicPlace,
    licensePlate: licensePlate,
    streamUrl: streamUrl
    };

    console.log("Received item:", item);
    this.item= item;
    },

    methods:{
        
    getElkImgUrl(item) {
      return Utils.transElkImgByNginx(item.streamUrl);
    },

    generateFileName(){
        return `${moment(this.item.dt).format('YYYY_MM_DD_HH_mm')}_${this.item.licensePlate}.jpg`
    },

    async addWatermark() {
            const img = new Image();
            img.crossOrigin="anonymous"
            img.src = this.getElkImgUrl(this.item);
            await img.decode();

            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');
            canvas.width = img.width;
            canvas.height = img.height;
       
            ctx.drawImage(img, 0, 0);

            ctx.font = '22px Arial';
            ctx.fillStyle = 'rgba(255, 255, 255, 1)'; 
            const text = `${this.item.area}_${this.item.publicPlace}`
            const textWidth = ctx.measureText(text).width;
            const textHeight = parseInt(ctx.font, 20);
            ctx.fillText(text, 15, textHeight + 20);
        
            this.downloadLink = canvas.toDataURL('image/jpeg');
            // console.log("downloadLink", this.downloadLink); 
        },

    },
    
    mounted(){
        this.addWatermark();
    }

    
}

</script>

<style  scoped>


.letter-spacing-1 {
  letter-spacing: 3px;
}

</style>